import { createReducer } from 'redux-recompose';
import { actions } from './actions';
import AuthorizationReducers from './authentication/reducer';
import NotifierReducers from './notifier/reducer';
import FiltersReducers from './filters/reducer';
import OptionsSelectReducers from './optionsSelect/reducer';
import FailureReportReducers from './failureReport/reducer';
import CounterMaterialReducer from './counterMaterial/reducer';
import DismissionReportReducer from './dismissionReport/reducer'

const defaultState = {
  notification: {
    open: false,
    variant: '',
    message: ''
  },
};

// Ogni volta che definisco dei reducer in un altro file vanno importati qua dentro!
const reducerDescription = {
  ...AuthorizationReducers,
  ...NotifierReducers,
  ...FiltersReducers,
  ...OptionsSelectReducers,
  ...FailureReportReducers,
  ...CounterMaterialReducer,
  ...DismissionReportReducer,
  [actions.SET_SELECTEDELEMENTS]: (state, action) => { return { ...state, selectedElements: action.selectedElements } },
  [actions.SET_LISTAFORNITORE]: (state, action) => { return { ...state, listaFornitore: action.response } },
}

export const reducer = createReducer(defaultState, reducerDescription);